import React from "react"
import { graphql, StaticQuery, Link } from "gatsby"
import Post from "./post"
import { Button } from "react-bootstrap"
export default function NewsCat() {
  return (
    <div className="article-cat-blog">
      <div>
        <div className="title">
          <span className="badge">مقاله‌ها</span>
        </div>
        <Link to="/articlepage">
          <Button variant="outline-secondary" className="show-all-btn">
            تمام مقاله‌ها
          </Button>
        </Link>
      </div>
      <div className="cats-posts" id="cats-posts-scroll">
        <StaticQuery
          query={blogquery}
          render={data => {
            return (
              <div>
                {data.allMarkdownRemark.edges.map(({ node }) => (
                  <section className="posts">
                    <Post
                      key={node.id}
                      title={node.frontmatter.title}
                      date={node.frontmatter.date}
                      slug={node.fields.slug}
                      body={node.excerpt}
                      fluid={node.frontmatter.image.childImageSharp.fluid}
                    />
                  </section>
                ))}
              </div>
            )
          }}
        />
      </div>
    </div>
  )
}

const blogquery = graphql`
  query {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: 10
      filter: { frontmatter: { cat: { eq: "article" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date
            image {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            cat
          }
          excerpt(truncate: true)
          fields {
            slug
          }
        }
      }
    }
  }
`
